import axios from "@/api/config";

const template = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/template/pageList`, data);
  },
  addTemplate(data) {
    return axios.post(`${process.env.BASE_URL}/template/addTemplate`, data);
  },
  updateTemplate(data) {
    return axios.put(`${process.env.BASE_URL}/template/updateTemplate`, data);
  },
  getTemplateList(param) {
    return axios.get(`${process.env.BASE_URL}/template/getTemplateList`, {
      param
    });
  },
  deleteTemplate(data) {
    return axios.delete(`${process.env.BASE_URL}/template/deleteTemplate`, {
      data: data
    });
  },
  getTemplate(param) {
    return axios.get(
      `${process.env.BASE_URL}/template/getTemplate?id=${param}`
    );
  }
};

export default template;



// WEBPACK FOOTER //
// ./src/api/template.js